import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-bestheaderer',
  templateUrl: './bestheaderer.component.html',
  styleUrls: ['./bestheaderer.component.css']
})
export class BestheadererComponent implements OnInit {
  language: any = [];
  showLanguage: boolean = true;
  userPrefLang = localStorage.getItem('userPrefLang');
  loginId = localStorage.getItem('loginId');

  constructor(public translateService: TranslateService) { }

  ngOnInit() {
    
    if (localStorage.getItem('userPrefLang') == null) {
      localStorage.setItem('userPrefLang', 'en');
    }
    this.translateService.use(localStorage.getItem('userPrefLang'));
    this.switchLanguage(localStorage.getItem('userPrefLang'));
    this.language = [
      {label: 'English', value: 'en'},
      {label: 'Hindi', value: 'Hindi'},
      {label: 'Marathi', value: 'Marathi'},
      {label: 'Punjabi', value: 'Punjabi'},
      {label: 'Telugu', value: 'Telugu'}
    ];
  }

  userPrefLangUpdate(lang) {
    
   
  }

  switchLanguage(language: string) {
    this.translateService.use(language);
  }
}
